<template>
  <octicon
    icon="x"
    class="ds-close-icon"
    :height="24"
    @click="$emit('click', $event)"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'DialogCloseIcon',
  emits: ['click'],
});
</script>

<style lang="scss" scoped>
.ds-close-icon {
  @apply tw-ml-2 tw-h-6 tw-text-gray-medium-dark tw-cursor-pointer;

  &:hover {
    @apply tw-text-gray-dark;
  }
}
</style>
